define('OutSystems/ClientRuntime/modules/Database/IndexedDB/IndexedDBEntityService',["require", "exports", "tslib", "../../../DataTypes", "../../../Exceptions", "../../../Logger", "../AutoNumber", "../Common/EntityService", "../Metadata/MetadataTableInfo", "../TableInfoUtils", "./IndexedDBSerializer", "./Upgrader/IndexedDBMetadataV2Upgrader"], function (require, exports, tslib_1, DataTypes_1, Exceptions_1, Logger, AutoNumber_1, EntityService_1, MetadataTableInfo_1, TableInfoUtils, IndexedDBSerializer_1, IndexedDBMetadataV2Upgrader_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var IndexedDBEntityService = (function (_super) {
        tslib_1.__extends(IndexedDBEntityService, _super);
        function IndexedDBEntityService() {
            return _super.call(this, new IndexedDBSerializer_1.default()) || this;
        }
        IndexedDBEntityService.prototype.executeAggregate = function (body, affectedTables) {
            return tslib_1.__awaiter(this, void 0, void 0, function () {
                var database, error_1;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, this.getDatabase()];
                        case 1:
                            database = _a.sent();
                            _a.label = 2;
                        case 2:
                            _a.trys.push([2, 4, , 5]);
                            return [4, database.executeQuery(body, true, affectedTables)];
                        case 3: return [2, _a.sent()];
                        case 4:
                            error_1 = _a.sent();
                            throw new Exceptions_1.Exceptions.DataBaseException("", error_1.message, error_1.stack);
                        case 5: return [2];
                    }
                });
            });
        };
        IndexedDBEntityService.prototype.innerCreate = function (transaction, info, record) {
            return tslib_1.__awaiter(this, void 0, void 0, function () {
                var metaDataRecord, pkAttr, dbRecord, identifier;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, this.getMetadataRecord(transaction, info)];
                        case 1:
                            metaDataRecord = (_a.sent());
                            pkAttr = TableInfoUtils.getIdentifierAttribute(info, record);
                            dbRecord = record.clone();
                            if (!(info.idIsAutoNumber === AutoNumber_1.default.YesIfEmpty)) return [3, 3];
                            identifier = this.getRecordIdAndUpdateLastIdentifier(metaDataRecord, info, record);
                            return [4, this.updateMetadataTable(transaction, metaDataRecord)];
                        case 2:
                            _a.sent();
                            dbRecord[pkAttr.attrName] = identifier;
                            _a.label = 3;
                        case 3: return [4, transaction.insertRecord(info, this.serializer.serialize(dbRecord, info))];
                        case 4:
                            _a.sent();
                            if (!pkAttr) {
                                return [2, null];
                            }
                            return [2, dbRecord[pkAttr.attrName]];
                    }
                });
            });
        };
        IndexedDBEntityService.prototype.getRecordIdAndUpdateLastIdentifier = function (metaDataRecord, info, record) {
            var pkCol = TableInfoUtils.getIdentifierColumn(info);
            var pkAttr = TableInfoUtils.getIdentifierAttribute(info, record);
            var identifierValue = TableInfoUtils.getIdentifierValue(info, record);
            if (info.idIsAutoNumber === AutoNumber_1.default.YesIfEmpty) {
                var lastRecordId = metaDataRecord.LASTIDENTIFIER !== undefined
                    ? this.serializer.deserialize(metaDataRecord.LASTIDENTIFIER, pkCol)
                    : DataTypes_1.defaultForType(pkAttr.dataType);
                if (DataTypes_1.equals(identifierValue, DataTypes_1.defaultForType(pkAttr.dataType))) {
                    if (lastRecordId instanceof DataTypes_1.LongInteger) {
                        lastRecordId = lastRecordId.add(1);
                    }
                    else if (typeof lastRecordId === "number") {
                        lastRecordId = lastRecordId + 1;
                    }
                    identifierValue = lastRecordId;
                    metaDataRecord.LASTIDENTIFIER = this.serializer.serialize(identifierValue, pkCol);
                }
                else if (DataTypes_1.compare(identifierValue, lastRecordId) > 0) {
                    metaDataRecord.LASTIDENTIFIER = this.serializer.serialize(identifierValue, pkCol);
                }
            }
            return identifierValue;
        };
        IndexedDBEntityService.prototype.innerCreateOrUpdate = function (transaction, info, record) {
            return tslib_1.__awaiter(this, void 0, void 0, function () {
                var dbRecord, metaDataRecord, recordId, pkAttr, insertedRecordId, pkCol;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            dbRecord = record.clone();
                            if (!(info.idIsAutoNumber === AutoNumber_1.default.YesIfEmpty)) return [3, 3];
                            return [4, this.getMetadataRecord(transaction, info)];
                        case 1:
                            metaDataRecord = (_a.sent());
                            recordId = this.getRecordIdAndUpdateLastIdentifier(metaDataRecord, info, record);
                            return [4, this.updateMetadataTable(transaction, metaDataRecord)];
                        case 2:
                            _a.sent();
                            pkAttr = TableInfoUtils.getIdentifierAttribute(info, record);
                            dbRecord[pkAttr.attrName] = recordId;
                            _a.label = 3;
                        case 3: return [4, transaction.upsertRecord(info, this.serializer.serialize(dbRecord, info))];
                        case 4:
                            insertedRecordId = _a.sent();
                            pkCol = TableInfoUtils.getIdentifierColumn(info);
                            if (!pkCol) {
                                return [2, null];
                            }
                            return [2, this.serializer.deserialize(insertedRecordId, pkCol)];
                    }
                });
            });
        };
        IndexedDBEntityService.prototype.innerCreateOrUpdateAll = function (transaction, info, records) {
            return tslib_1.__awaiter(this, void 0, void 0, function () {
                var metaDataRecord, pkAttr, serializedRecords;
                var _this = this;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, this.getMetadataRecord(transaction, info)];
                        case 1:
                            metaDataRecord = (_a.sent());
                            serializedRecords = records.map(function (record) {
                                pkAttr = pkAttr !== null && pkAttr !== void 0 ? pkAttr : TableInfoUtils.getIdentifierAttribute(info, record);
                                var dbRecord = record.clone();
                                if (info.idIsAutoNumber === AutoNumber_1.default.YesIfEmpty) {
                                    var newRecordId = _this.getRecordIdAndUpdateLastIdentifier(metaDataRecord, info, record);
                                    dbRecord[pkAttr.attrName] = newRecordId;
                                }
                                return _this.serializer.serialize(dbRecord, info);
                            });
                            return [4, this.updateMetadataTable(transaction, metaDataRecord)];
                        case 2:
                            _a.sent();
                            return [2, transaction.upsertAllRecords(info, serializedRecords)];
                    }
                });
            });
        };
        IndexedDBEntityService.prototype.registerInitializer = function (entityInfos) {
            _super.prototype.registerInitializer.call(this, entityInfos);
            if (entityInfos && entityInfos.length > 0) {
                Logger.trace(this, "Registering V2 upgrader for entities of module '" + entityInfos[0].moduleKey + "'.");
                var initializer = new IndexedDBMetadataV2Upgrader_1.default(entityInfos, this.serializer);
                this.database.registerInitializer(initializer);
            }
        };
        IndexedDBEntityService.prototype.getMetadataRecord = function (transaction, info) {
            return tslib_1.__awaiter(this, void 0, void 0, function () {
                var metadataRecord;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, transaction.getRecord(MetadataTableInfo_1.default, [info.key, info.moduleKey])];
                        case 1:
                            metadataRecord = _a.sent();
                            if (!metadataRecord) {
                                throw new Error("Unable to fetch record with key " + info.key + " and moduleKey " + info.moduleKey + " from \n                metadata table " + MetadataTableInfo_1.default.tableName + ".");
                            }
                            return [2, metadataRecord];
                    }
                });
            });
        };
        IndexedDBEntityService.prototype.updateMetadataTable = function (transaction, metaDataRecord) {
            return tslib_1.__awaiter(this, void 0, void 0, function () {
                return tslib_1.__generator(this, function (_a) {
                    if (metaDataRecord.LASTIDENTIFIER !== undefined) {
                        return [2, transaction.updateRecord(MetadataTableInfo_1.default, metaDataRecord)];
                    }
                    return [2];
                });
            });
        };
        return IndexedDBEntityService;
    }(EntityService_1.default));
    exports.default = IndexedDBEntityService;
});
//# sourceMappingURL=IndexedDBEntityService.js.map;
